module.exports = __webpack_public_path__ + "static/img/peopleGame2.bcdff43.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/video/peopleGame2.webp
// module id = JPM1
// module chunks = 3